export const GET_RATES = "GET_RATES";
export const GET_RATES_SUCCESS = "GET_RATES_SUCCESS";
export const GET_RATES_FAIL = "GET_RATES_FAIL";

export const ADD_RATES_SUCCESS = "ADD_RATES_SUCCESS";
export const ADD_RATES_FAIL = "ADD_RATES_FAIL";
export const UPDATE_RATES_SUCCESS = "UPDATE_RATES_SUCCESS";
export const DELETE_RATES_SUCCESS = "DELETE_RATES_SUCCESS";
